import { render } from "./FooterLinks.vue?vue&type=template&id=549d00a4&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=549d00a4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549d00a4"]])

export default __exports__